import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useApplicationConfig} from "../../../../app/modules/application-configuration/core/ApplicationConfiguration";
import slugify from "../../../../app/helpers/utils/slugify";
import {MenuEntry} from "../../../../app/modules/application-configuration/core/_models";

export function MenuInner() {
    const {menu} = useApplicationConfig()

    const renderMenuItem = (menuItem: MenuEntry, prefix?: string) => {
        const slug = (prefix != null ? prefix + '/' : '') + [menuItem.id, slugify(menuItem.title)].join('-');
        const url = 'page/' + slug;

        if (menuItem.items !== undefined && menuItem.items.length !== 0) {
            return <MenuInnerWithSub
                key={menuItem.num + menuItem.title}
                title={menuItem.title}
                to={url}
                menuPlacement={!prefix ? 'bottom-start' : 'left-start'}
                menuTrigger={!prefix ? 'click' : `{default:'click', lg: 'hover'}`}
                hasArrow={true}
            >
                {menuItem.items.map(item => renderMenuItem(item, slug))}
            </MenuInnerWithSub>
        }

        return <MenuItem key={menuItem.num + menuItem.title} title={menuItem.title} to={url}/>
    }

    return (
        <>
            {menu!.items.map((menuItem) => renderMenuItem(menuItem))}
        </>
    )
}
